module.exports = new __parcel__URL__("exclamation-triangle-yellow.a39d9b20.svg").toString();